import { render, staticRenderFns } from "./TransferSyllablesForm.vue?vue&type=template&id=34acb046&scoped=true&lang=pug&"
import script from "./TransferSyllablesForm.vue?vue&type=script&lang=js&"
export * from "./TransferSyllablesForm.vue?vue&type=script&lang=js&"
import style0 from "./TransferSyllablesForm.vue?vue&type=style&index=0&id=34acb046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34acb046",
  null
  
)

export default component.exports